import { AiFillGithub, AiOutlineInstagram, AiOutlineLinkedin, AiOutlineTwitter } from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://www.instagram.com/prophetmarquice/?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://twitter.com/profitmarquice', icon: <AiOutlineTwitter/>},
    {id: 3, link: 'https://www.linkedin.com/in/marquice-b-376a67227/', icon: <AiOutlineLinkedin/>},
    {id: 4, link: 'https://github.com/GoldenMarquice', icon: <AiFillGithub/>}
]

export default data